<template>
  <div>
    <SelectOption />
    <grid-manager :option="gridOption" ref="grid"></grid-manager>
    <div class='tip-text'>当前界面数据实时更新</div>
  </div>
</template>

<script>
import { 
  PAGE_TITLE,
  getBaseData,
  getAccountData,
  getWorksData,
  getSocialData,
  getLocationData,
  getDeviceData 
} from '../utils/contants';
import { getParams } from '@/utils/url';
import SelectOption from '../components/select-option.vue'

const DATA_FUNC = {
  base:getBaseData,
  account:getAccountData,
  works:getWorksData,
  social:getSocialData,
  location:getLocationData,
  device:getDeviceData
}

export default {
  name: "TableList",
  components: {
    SelectOption
  },
  data() {
        return {
        gridOption : {
            //表格唯一标识
            gridManagerName: 'info-collect',
            supportCheckbox: false,
            supportAutoOrder: false,
            supportAdjust: false,
            supportExport: false,
            supportDrag: false,
            disableBorder: true,
            disableLine:true,
            lineHeight:'100px',
            useWordBreak:true,
            height:'100%',
            disableAutoLoading:true,
            // 列配置
            columnData: [
              {
                key: 'infoName',
                text: '信息名称',
              },{
                key: 'useReason',
                text: '使用目的',
              },{
                key: 'useScene',
                text: '使用场景',
              },{
                key: 'collectStatus',
                text: '收集情况',
              },{
                key: 'collectData',
                text: '收集内容',
                align: 'center',
                template: function(title, rowObject) {
                  console.log('rowObject:',title,rowObject)
                  if(title.startsWith('linkType')){
                    var titleNode = document.createElement('a');
                    titleNode.setAttribute('href', title.split('linkType')[1]);
                    titleNode.setAttribute('title', title);
                    titleNode.setAttribute('target', '_blank');
                    titleNode.innerText = '查看详情';
                    titleNode.classList.add('plugin-action');
                    return titleNode;
                  }else{
                    return title
                  }
                }
              }
            ],
            ajaxData: DATA_FUNC[getParams().type || 'base'](),
        }
    }
  },
  created(){
    document.title = PAGE_TITLE[getParams().type]
  },
}
</script>

<style lang="less" scoped>
  .tip-text{
    background: #FFFFFF;
    font-family: 'PingFang SC';
    padding: 0.48rem 0;
    font-weight: 400;
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
